export default function validaNomeComSobrenome(nomeSobrenome) {
  const nomes = nomeSobrenome.split(' ');
  return nomes.length > 1
    && nomes.every(nome => nome.match(/[a-z\u00C0-\u00FF]+/i));
}
